module.exports = __webpack_public_path__ + "static/media/mens_3.c57be847.jpg";